<template>
  <div>
    <b-tabs>
      <b-tab :title="$t('message.Общие')" active>
        <b-row>
          <b-col class="col-5">
            <b-form-group
              :label="$t('message.Название') + ':'"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                type="text"
                v-model="model.name"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="col-2">
            <b-form-group :label="$t('message.Логотип')" label-for="Logo">
              <b-form-file
                accept="image/*"
                v-model="model.image"
                @change="onFileChange"
                :state="Boolean(model.image)"
                placeholder="Choose a file..."
              ></b-form-file>
            </b-form-group>
          </b-col>
          <b-col class="col-4">
            <img v-if="model.image_url" :src="model.image_url" width="64" />
            <!-- <div class="mt-3" v-if="model.image_url">
              <img :src="model.image_url" width="64" />
            </div> -->
          </b-col>
        </b-row>
        <b-form-group
          :label="$t('message.Видеотека_-_Описание') + ':'"
          label-for="Description"
        >
          <b-form-textarea
            id="Description"
            v-model="model.description"
            rows="2"
          ></b-form-textarea>
        </b-form-group>
        <b-row>
          <b-col class="col-2">
            <b-form-group
              :label="$t('message.Минимальный_возраст') + ':'"
              label-for="Rating"
            >
              <b-form-input
                id="Rating"
                type="number"
                v-model="model.min_age"
                value="0"
                min="0"
                max="21"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="col-2">
            <b-form-group
              :label="$t('message.Видеотека_-_Год') + ':'"
              label-for="Year"
            >
              <b-form-input
                id="Year"
                type="number"
                v-model="model.year"
                value=""
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="col-2">
            <b-form-group
              :label="$t('message.Видеотека_-_Продолжительность') + ':'"
              label-for="Duration"
            >
              <b-form-input
                id="Duration"
                type="number"
                v-model="model.duration"
                value=""
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="col-4">
            <b-form-group
              :label="$t('message.Видеотека_-_Режисеры') + ':'"
              label-for="Directors"
            >
              <b-form-input
                id="Directors"
                type="text"
                v-model="model.directors"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group
          :label="$t('message.Видеотека_-_Актеры') + ':'"
          label-for="Actors"
        >
          <b-form-textarea
            id="Actors"
            v-model="model.actors"
            rows="1"
          ></b-form-textarea>
        </b-form-group>
        <b-row>
          <b-col class="col-6">
            <b-form-group
              :label="$t('message.Видеотека_-_Жанры') + ':'"
              label-for="Genres"
            >
              <v-select
                multiple
                v-model="model.vod_genres"
                :options="this.vod_genres"
                label="name"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col class="col-6">
            <b-form-group
              :label="$t('message.Страны') + ':'"
              label-for="Countries"
            >
              <v-select
                multiple
                v-model="model.countries"
                :options="this.countries"
                label="name"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab :title="$t('message.Видеотека_-_Контроль')">
        <b-form-group>
          <b-form-checkbox v-model="model.enabled" switch>
            {{ $t("message.Включен") }}</b-form-checkbox
          >
        </b-form-group>
        <!-- <b-form-group> <b-form-checkbox v-model="model.market_accessable" switch>
            {{ $t("message.Выгружать_в_ios") }}</b-form-checkbox
          > 
        </b-form-group>-->
        <b-form-group
          :label="$t('message.Пакеты') + ':'"
          label-for="VodPackages"
        >
          <v-select
            multiple
            v-model="model.vod_packages"
            :options="this.vod_packages"
            label="name"
          ></v-select>
        </b-form-group>
      </b-tab>
      <b-tab :title="$t('message.Geo_контроль')">
        <b-form-group>
          <b-form-checkbox v-model="model.geo_enabled" switch>{{
            $t("message.Geo_enabled")
          }}</b-form-checkbox>
        </b-form-group>
        <b-form-group :label="$t('message.Geo_тип_списка')">
          <b-form-radio-group>
            <b-form-radio
              v-model="model.geo_type_list"
              name="GeoTypeList"
              value="BLACK"
              >Black</b-form-radio
            >
            <b-form-radio
              v-model="model.geo_type_list"
              name="GeoTypeList"
              value="WHITE"
              >White</b-form-radio
            >
          </b-form-radio-group>
        </b-form-group>
        <b-form-group :label="$t('message.Geo_коды')" label-for="Countries">
          <v-select
            multiple
            v-model="model.geo_codes"
            :options="this.geo_codes_list"
            label="name"
          ></v-select>
        </b-form-group>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
export default {
  name: "VodMovieForm",
  props: ["model"],
  data() {
    return {
      countries: [],
      vod_packages: [],
      vod_streams: [],
      vod_genres: [],
      geo_codes_list: []
    };
  },
  beforeUpdate() {},
  created: function() {
    this.epg_image = null;
    let countries = this.$noname.get("countries", {
      params: { perPage: 10000 }
    });
    let promise = this.$noname.get("vod_packages", {
      params: { perPage: 10000 }
    });
    let vod_genres = this.$noname.get("vod_genres", {
      params: { perPage: 10000 }
    });
    let geo_codes_list = this.$noname.get("geo_country_codes", {
      params: { perPage: 10000 }
    });

    countries
      .then(data => {
        this.countries = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Ошибка_получения_данных") + ":<br>" + error,
          type: "error"
        });
      });

    promise
      .then(data => {
        this.vod_packages = data.data.items;
      })
      .catch(this.$noname.HandleError);

    vod_genres
      .then(data => {
        this.vod_genres = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Ошибка_получения_данных") + ":<br>" + error,
          type: "error"
        });
      });

    geo_codes_list
      .then(data => {
        this.geo_codes_list = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Geo_не_удалось_получить_список_кодов_стран") +
            ":<br>" +
            error,
          type: "error"
        });
      });
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.model.image = reader.result;
        }.bind(this),
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/VodMovieForm.vue